import { ApiDeviceListItemDeviceStatus } from './../api/types/device';

const deviceBgColorSelector = (
    staticBgcolor: string | null,
    deviceStatusArr: Array<ApiDeviceListItemDeviceStatus> | undefined,
) => {
    let bgColor = '#fff';
    let deviceStatus = deviceStatusArr;

    if (staticBgcolor) {
        bgColor = staticBgcolor;
    } else if (deviceStatus && deviceStatus.length > 0) {
        deviceStatus = [...deviceStatus];
        deviceStatus.sort(function (a, b) {
            return a.Priority - b.Priority;
        });
        bgColor = deviceStatus[0].Color;
    } else {
        bgColor = '#fff';
    }

    return bgColor;
};

export default deviceBgColorSelector;
